module.exports = __webpack_public_path__ + "img/model.d2343e75.jpg";